module.exports = __webpack_public_path__ + "static/media/sample_units.0adbe0e5.csv";